const normalizeToken = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const FEMALE_NAMES = new Set([
  'abigail',
  'adriana',
  'agostina',
  'agustina',
  'alejandra',
  'alicia',
  'amanda',
  'ana',
  'andrea',
  'angela',
  'antonella',
  'ayelen',
  'barbara',
  'beatriz',
  'belen',
  'bianca',
  'camila',
  'carla',
  'carolina',
  'catalina',
  'cecilia',
  'clara',
  'claudia',
  'cristina',
  'daniela',
  'diana',
  'elena',
  'eliana',
  'elisa',
  'elizabeth',
  'emilia',
  'estefania',
  'esther',
  'eugenia',
  'eva',
  'fabiana',
  'fatima',
  'fernanda',
  'florencia',
  'francisca',
  'gabriela',
  'gisele',
  'gladys',
  'graciela',
  'guadalupe',
  'ines',
  'irene',
  'isabel',
  'jessica',
  'jimena',
  'josefina',
  'julia',
  'juliana',
  'julieta',
  'karen',
  'karina',
  'laura',
  'leticia',
  'liliana',
  'lorena',
  'lourdes',
  'lucia',
  'luciana',
  'luisa',
  'lujan',
  'malena',
  'marcela',
  'margarita',
  'maria',
  'mariana',
  'mariel',
  'mariela',
  'marina',
  'marta',
  'matilde',
  'melina',
  'melisa',
  'michelle',
  'miriam',
  'mirta',
  'monica',
  'morena',
  'natalia',
  'nicole',
  'noelia',
  'nora',
  'norma',
  'olga',
  'paula',
  'patricia',
  'pilar',
  'raquel',
  'rebeca',
  'regina',
  'romina',
  'rosa',
  'rosario',
  'roxana',
  'ruth',
  'sabrina',
  'sandra',
  'sara',
  'silvia',
  'silvina',
  'sofia',
  'sol',
  'soledad',
  'susana',
  'tamara',
  'teresa',
  'valentina',
  'vanesa',
  'vanina',
  'veronica',
  'victoria',
  'vilma',
  'virginia',
  'viviana',
  'yamila',
  'yesica',
  'yolanda',
]);

const MALE_NAMES = new Set([
  'adrian',
  'agustin',
  'alan',
  'alberto',
  'alejandro',
  'alexis',
  'alfredo',
  'alvaro',
  'andres',
  'angel',
  'antonio',
  'arian',
  'armando',
  'benjamin',
  'bruno',
  'carlos',
  'cesar',
  'christian',
  'claudio',
  'cristian',
  'damian',
  'daniel',
  'dario',
  'david',
  'diego',
  'eduardo',
  'emiliano',
  'emilio',
  'enrique',
  'ernesto',
  'esteban',
  'eugenio',
  'facundo',
  'federico',
  'felipe',
  'fernando',
  'francisco',
  'franco',
  'gabriel',
  'gaston',
  'gonzalo',
  'guillermo',
  'gustavo',
  'hector',
  'hernan',
  'hugo',
  'ignacio',
  'ivan',
  'javier',
  'jesus',
  'joaquin',
  'jorge',
  'jose',
  'juan',
  'julian',
  'julio',
  'leonardo',
  'lucas',
  'luis',
  'manuel',
  'marcelo',
  'marcos',
  'martin',
  'mateo',
  'matias',
  'mauricio',
  'maximiliano',
  'miguel',
  'nahuel',
  'nicolas',
  'octavio',
  'oscar',
  'pablo',
  'patricio',
  'pedro',
  'ramiro',
  'raul',
  'ricardo',
  'roberto',
  'rodrigo',
  'ruben',
  'salvador',
  'santiago',
  'sebastian',
  'sergio',
  'tomas',
  'victor',
  'walter',
]);

const MALE_NAMES_ENDING_A = new Set(['joshua', 'luca', 'matia', 'mustafa', 'nikola', 'sasha']);

const extractFirstName = (nombreApellido) => {
  const parts = String(nombreApellido || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '';
  return normalizeToken(parts[0]);
};

export const inferSexoFromNombre = (nombreApellido) => {
  const first = extractFirstName(nombreApellido);
  if (!first) return null;

  if (FEMALE_NAMES.has(first)) return 'F';
  if (MALE_NAMES.has(first)) return 'M';

  if (first.endsWith('a') && !MALE_NAMES_ENDING_A.has(first)) return 'F';
  if (first.endsWith('o') || first.endsWith('os') || first.endsWith('el')) return 'M';

  return null;
};

export const sexoDisplay = (sexo, nombreApellido) => {
  const value = sexo || inferSexoFromNombre(nombreApellido);
  return value === 'M' || value === 'F' ? value : '—';
};
